import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import translations from '../../services/translations/translations';
import {
  LANGUAGE_NAMES,
  SUPPORTED_LANGUAGES,
} from '../../services/translations/languages';
import { RootState } from '../../store/store';
import { updateUserLanguage as updateUserLanguageAction } from '../../store/users/actions';
import '../../style/layout/form/SidebarLink.css';
import '../../style/layout/SidebarLanguage.css';

const SidebarLanguage = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation([translations.common]);

  const user = useSelector((state: RootState) => state.users.current);

  if (user === null) {
    return null;
  }

  return (
    <div
      className="sidebar-link sidebar-language"
      style={{ marginTop: 'auto' }}
    >
      <p className="sidebar-link-text">{t('Language')}</p>
      <div className="sidebar-language-options">
        {SUPPORTED_LANGUAGES.map((language) => (
          <button
            key={language}
            type="button"
            lang={language}
            className={
              i18n.language === language
                ? 'sidebar-language-option active'
                : 'sidebar-language-option'
            }
            aria-pressed={i18n.language === language}
            onClick={() => dispatch(updateUserLanguageAction(language))}
          >
            {LANGUAGE_NAMES[language]}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SidebarLanguage;
